import { useMutation, type UseMutationOptions } from '@tanstack/react-query';

import { MUTATION_KEY, QUERY_KEY } from './keys';
import { queryClient } from './queryClient';
import { clmApiClient } from '../clients';
import type {
  ApiErrorResponse,
  IDN,
  IDNCreateRequest,
  IDNCreateRequestBody,
} from '../types';
import { isApiErrorResponse } from '../utils';

const createIDN = async (data: IDNCreateRequest): Promise<IDN> => {
  const response = await clmApiClient.post<IDN, ApiErrorResponse>('idn', {
    idn: data,
  } as IDNCreateRequestBody);

  if (!response.data) {
    throw new Error('No data returned from create IDN');
  }

  if (!response.ok) {
    if (isApiErrorResponse(response.data)) {
      throw new Error(response.data.details);
    }
    throw new Error('Unknown error');
  }
  await queryClient.invalidateQueries({
    predicate: (query) => {
      const [key] = query.queryKey;

      return key === QUERY_KEY.IDN_SEARCH;
    },
  });

  return response.data;
};

export const useIDNCreateMutation = (
  config?: Omit<UseMutationOptions<IDN, Error, IDNCreateRequest>, 'mutationFn'>,
) =>
  useMutation({
    mutationKey: [MUTATION_KEY.IDN_CREATE],
    mutationFn: createIDN,
    ...config,
  });
